import React, { useMemo, useEffect, useCallback } from 'react';
import { useHistory } from "react-router-dom";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendarDay, faDiagnoses, faTag } from '@fortawesome/free-solid-svg-icons';

import DatabaseDataStudentRequests from './school_data/database_data_student_requests';
import DatabaseDataSections from './school_data/database_data_sections';
import DatabaseDataLabels from './school_data/database_data_labels';

import manage_data from '../../images/manage_data.png';
import { buildSupervisorScope } from './utils/supervisorScope';

import '../../css/school_data.css';

export default function SchoolData({ match, schoolInfo, scheduleInfo, scheduleStructureData, setLoadScreen, schoolType, userInfo, departments, teachersLoading, teachers, setTeachers, coursesLoading, courses, setCourses, classrooms, studentsLoading, students, setStudents, sectionsLoading, sections, setSections, subsections, setSubsections, lunchInfo, labels, setLabels, handlePullNewData }) {
	const history = useHistory();
	const supervisorScope = useMemo(() => buildSupervisorScope({userInfo, departments, courses, teachers, classrooms, sections}), [userInfo, departments, courses, teachers, classrooms, sections]);
	const isSupervisor = supervisorScope.isSupervisor;
	const isCounselor = userInfo && `${userInfo.role_id}` === '4';
	const requestsReadOnly = isSupervisor || isCounselor;
	const departmentFilterOptions = isSupervisor ? supervisorScope.visibleDepartments : (Array.isArray(departments) ? departments : []);
	const showDepartmentFilter = !isSupervisor || departmentFilterOptions.length > 1;

	//////////////////////
	///// FUNCTIONS /////
	/////////////////////
	const goToScreen = useCallback((screen) => {
		sessionStorage.clear();

		history.push(`/app/${schoolType}/scheduling_data/${screen}/`);
		setLoadScreen('scheduling_data');
	}, [history, schoolType, setLoadScreen]);

	useEffect(() => {
		if((isSupervisor || isCounselor) && match.params.screen === 'labels') goToScreen('requests');
	}, [goToScreen, isCounselor, isSupervisor, match.params.screen]);
	
	return (
		<div id='school-data-main-container'>
			<div id='school-data-sidebar'>
				<div className='secondary-sidebar-header'>Data</div>
				<div className={`school-data-sidebar-btn ${match.params.screen === 'requests' ? 'school-data-sidebar-btn-selected' : ''}`} onClick={(match.params.screen !== 'requests') ? (() => goToScreen('requests')) : null}>
						<FontAwesomeIcon className='school-data-sidebar-icon' icon={faDiagnoses}/>
						<div className='school-data-sidebar-step-name'>Requests</div>
				</div>
				<div className={`school-data-sidebar-btn ${match.params.screen === 'sections' ? 'school-data-sidebar-btn-selected' : ''}`} onClick={(match.params.screen !== 'sections') ? (() => goToScreen('sections')) : null}>
						<FontAwesomeIcon className='school-data-sidebar-icon' icon={faCalendarDay}/>
						<div className='school-data-sidebar-step-name'>Sections</div>
				</div>
				{!isSupervisor && !isCounselor && <div className={`school-data-sidebar-btn ${match.params.screen === 'labels' ? 'school-data-sidebar-btn-selected' : ''}`} onClick={(match.params.screen !== 'labels') ? (() => goToScreen('labels')) : null}>
						<FontAwesomeIcon className='school-data-sidebar-icon' icon={faTag}/>
						<div className='school-data-sidebar-step-name'>Labels</div>
				</div>}
			</div>
			<div id='school-data-main-content'>
				{(() => {
					if((isSupervisor || isCounselor) && match.params.screen === 'labels') {
						return <DatabaseDataStudentRequests schoolInfo={schoolInfo} scheduleInfo={scheduleInfo} coursesLoading={coursesLoading} courses={isSupervisor ? supervisorScope.visibleCourses : courses} studentsLoading={studentsLoading} students={students} setStudents={setStudents} sections={sections} setSections={setSections} departments={departments} handlePullNewData={handlePullNewData} readOnly={requestsReadOnly} departmentFilterOptions={departmentFilterOptions} showDepartmentFilter={showDepartmentFilter}/>;
					}

					switch(match.params.screen) {
						case 'requests':
							return <DatabaseDataStudentRequests schoolInfo={schoolInfo} scheduleInfo={scheduleInfo} coursesLoading={coursesLoading} courses={isSupervisor ? supervisorScope.visibleCourses : courses} studentsLoading={studentsLoading} students={students} setStudents={setStudents} sections={sections} setSections={setSections} departments={departments} handlePullNewData={handlePullNewData} readOnly={requestsReadOnly} departmentFilterOptions={departmentFilterOptions} showDepartmentFilter={showDepartmentFilter}/>;
						case 'sections':
							return <DatabaseDataSections schoolInfo={schoolInfo} databaseData={sections} setDatabaseData={setSections} scheduleStructureData={scheduleStructureData} scheduleInfo={scheduleInfo} courses={courses} setCourses={setCourses} teachers={teachers} setTeachers={setTeachers} classrooms={classrooms} students={students} setStudents={setStudents} departments={departments} sections={sections} setSections={setSections} subsections={subsections} setSubsections={setSubsections} labels={labels} setLabels={setLabels} lunchInfo={lunchInfo} dataIsLoading={sectionsLoading} coursesLoading={coursesLoading} readOnlyAddUpload={isSupervisor || isCounselor} visibleDataFilter={isSupervisor ? supervisorScope.sectionIsInScope : null} studentOnlySectionEditing={isCounselor} departmentFilterOptions={departmentFilterOptions} showDepartmentFilter={showDepartmentFilter}/>;
						case 'labels':
							return <DatabaseDataLabels schoolInfo={schoolInfo} scheduleInfo={scheduleInfo} scheduleStructureData={scheduleStructureData} labels={labels} setLabels={setLabels} sections={sections} setSections={setSections} students={students} setStudents={setStudents} courses={courses} setCourses={setCourses} teachers={teachers} setTeachers={setTeachers} classrooms={classrooms} subsections={subsections} setSubsections={setSubsections} lunchInfo={lunchInfo} sectionsLoading={sectionsLoading} studentsLoading={studentsLoading} coursesLoading={coursesLoading} teachersLoading={teachersLoading}/>;
						default:
							return (
								<div id='school-data-welcome-screen'>
									<img id='school-data-welcome-screen-image' src={manage_data} alt='Manage Data Img'/>
									<h1 className='main-header'>Manage Your Data</h1>
									<p className='subheader' style={{margin:'-20px auto 50px auto'}}>Control all your school's data in one place</p>
								</div>
							);
					}
				})()}
			</div>
		</div>
	);
}
